/** Generated from Veeso_Landing_Page_ja_translated.md */
export const landingUnifiedJa = {
  solutions: {
    detail: {
      team_cta: 'チームを止まらない存在に',
    },
  },
};
